import { Dictionary } from '@/types';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class FilterMixin extends Vue {
  get filterValues(): Dictionary<any> {
    return {
      ...this.$route.query,
      ...this.$route.params,
    };
  }

  get filterFields() {
    const {
      industries,
      professions,
      profSpheres,
      workTypes,
      workSpheres,
      profStandarts,
    } = this.$store.state;
    // Профессии
    return [
      {
        title: 'Отрасль',
        code: 'industry_id',
        data: [
          {
            name: 'Любая отрасль',
            id: '',
          },
          ...industries,
        ],
        filterable: 'auto',
      },
      // {
      //   title: 'Вид труда',
      //   code: 'work_type',
      //   data: [
      //     {
      //       name: 'Любой вид',
      //       id: '',
      //     },
      //     ...workTypes,
      //   ],
      //   filterable: 'auto',
      // },
      // {
      //   title: 'Сфера труда',
      //   code: 'work_sphere',
      //   data: [
      //     {
      //       name: 'Любая сфера',
      //       id: '',
      //     },
      //     ...workSpheres,
      //   ],
      //   filterable: 'auto',
      // },
      // {
      //   title: 'Профессиональная область',
      //   code: 'prof_sphere_id',
      //   data: [
      //     {
      //       name: 'Любая область',
      //       id: '',
      //     },
      //     ...profSpheres,
      //   ],
      //   filterable: 'auto',
      // },
      {
        title: 'Профессиональный стандарт',
        code: 'prof_standard_id',
        data: [
          {
            name: 'Любой стандарт',
            id: '',
          },
          ...profStandarts,
        ],
        filterable: 'auto',
      },
      {
        title: 'Наименование',
        code: 'name',
        data: [
          {
            name: 'Любое наименование',
            id: '',
          },
          ...professions.map(({ name }: any) => ({ id: name, name })),
        ],
        filterable: 'auto',
      },
      // {
      //   title: 'Мин. размер оплаты',
      //   type: 'input',
      //   code: 'pay_min',
      // },
      // {
      //   title: 'Макс. размер оплаты',
      //   type: 'input',
      //   code: 'pay_max',
      // },
      {
        title: 'Наличие программ по профессии',
        code: 'has_events',
        data: [
          {
            name: 'Не важно',
            id: '',
          },
          {
            name: 'Нет',
            id: '0',
          },
          {
            name: 'Да',
            id: '1',
          },
        ],
        filterable: 'auto',
      },
    ];
  }
}



// WEBPACK FOOTER //
// ./src/pages/professions/list/mixins/filter-mixin.ts